import React, { useState } from "react";
import FileManagerApp from "./Components/FileManagerApp";
import "./FileExplorer.css";

const FileExplorer = ({ user }) => {
  // Debug logging
  if (!user) {
    console.warn("FileExplorer: user prop is undefined or null");
    return (
      <div className="file-explorer-container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          Loading user information...
        </div>
      </div>
    );
  }

  // Validate slug format
  const isValidSlug =
    user.slug && typeof user.slug === "string" && user.slug.length > 0;

  if (!isValidSlug) {
    console.warn("FileExplorer: user.slug is invalid", {
      user,
      slug: user.slug,
      isValidSlug,
    });
    return (
      <div className="file-explorer-container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          Loading user information...
        </div>
      </div>
    );
  }

  return (
    <div className="file-explorer-container">
      <FileManagerApp user={user} />
    </div>
  );
};

export default FileExplorer;
